const modal = {
  cancelButton: 'Zurückweisen',
  confirmButton: 'Bestätigen',
  confirmChange: {
    title: 'Änderung bestätigen',
    body: 'Möchten Sie diese Änderung wirklich vornehmen?',
    confirmButton: 'Bestätigen',
    cancelButton: 'Stornieren',
    verificationPlaceholder: 'Geben Sie die Bestätigungssatz ein',
  },
};

export default modal;
